import { useEffect, useState } from "react";

function Redirect({ url = "/" }) {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    // Detect browser language
    const browserLang = navigator.language.toLowerCase();
    setLang(browserLang.startsWith("de") ? "de" : "en");
  }, []);

  useEffect(() => {
    window.location.href = url;
  }, [url]);

  const text = {
    de: {
      redirecting: "Sie werden weitergeleitet...",
      clickHere: "Klicken Sie hier, falls Sie nicht weitergeleitet werden"
    },
    en: {
      redirecting: "You are being redirected...",
      clickHere: "Click here if you are not redirected"
    }
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="flex flex-col gap-2 justify-center items-center">
        {text[lang].redirecting}
        <a href={url} className="text-neutral-400 text-sm underline">
          {text[lang].clickHere}
        </a>
      </div>
    </div>
  );
}

export default Redirect;
